import React from 'react';
import { getLoggedUser } from '../../../../state/user';
import i18n from '../../../../i18n';
import { SideBar } from '../../sidebar';
import FilterSection from '../../../common/Filter';
import Dropdown from '../../../common/DropDown';
import NoData from '../../../common/NoData';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import DataTable from 'react-data-table-component';
import { Download, Printer } from 'lucide-react';
import NewDropdown from '../../../common/NewDropDown';
import { getWinningAuctions, getWinningClients } from './services/winningBidService';
import StatusBadge from '../../../common/StatusBadge';
import { AUCTION_APPROVE_STATUS } from '../../../../constants/status';
import { apiUrl } from '../../../../constants/global';
import { getGroupsList } from '../../../../models/groups';
import HeaderBanner from '../../../common/HeaderBanner';

const user = getLoggedUser();

export class WinningBidList extends React.Component {
  constructor() {
    super();
    this.state = {
      search: {
        client: '',
        group: '',
        status: 'approved',
      },
      clients: [],
      groups: [],
      winningAuctions: [],
      isloading: false,
      limit: 15,
      page: 1,
      total: 0,
      groupLoading: false,
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    // Parse URL query params
    const params = new URLSearchParams(window.location.search);
    const search = {
      client: params.get('client') || '',
      group: params.get('group') || null,
      status: params.get('status') || 'P',
    };
    const page = parseInt(params.get('page')) || 1;
    const limit = parseInt(params.get('limit')) || 15;

    this.setState({ search, page, limit }, () => {
      this.getAllOrganization?.();
      this.getWinningAuctions();
    });
  }

  // Update URL without refreshing page
  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
  }
  async getWinningAuctions() {
    this.setState({ isloading: true });
    let { limit, page } = this.state;
    let { client, group } = this.state.search;
    const q = {
      page: page,
      limit: limit,
    };

    if (client) q.client = client;
    if (group) q.group = group;
    // Update URL
    this.updateUrlQuery(q);

    let response = await getWinningAuctions(q);
    if (response.success) {
      let winningAuctions = response.data;
      let { total } = response.meta;

      this.setState({
        winningAuctions,
        total,
        isloading: false,
      });
    }
    this.setState({ isloading: false });
  }
  async getAllOrganization() {
    const response = await getWinningClients();
    let clients = response.data;
    this.setState({ clients });
  }

  async getAllGroups() {
    this.setState({ groupLoading: true });
    let { client } = this.state.search;
    let q = client ? `organization=${client}` : '';
    const response = await getGroupsList(q);
    if (response.success) {
      let groups = response.data;
      this.setState({ groups });
      this.setState({ groupLoading: false });
    } else {
      this.setState({ groupLoading: false });
    }
  }

  getColumns = () => {
    return [
      {
        id: 1,
        name: 'Sl No',
        width: '70px',
        sortable: true,
        wrap: true,
        cell: (row, i) => i + 1,
      },
      {
        id: 2,
        name: 'ID',
        width: '80px',
        sortable: true,
        wrap: true,
        cell: (row) => row.id,
      },
      {
        id: 3,
        name: i18n.t('auction_name'),
        minWidth: '180px',
        cell: (row) => row.title,
      },
      {
        id: 4,
        name: i18n.t('client'),
        minWidth: '150px',
        cell: (row) => row.organization_name,
      },
      {
        id: 5,
        name: i18n.t('total_payable'),
        width: '120px',
        cell: (row) => Number(row.total_amount ?? 0).toFixed(3),
        wrap: true,
        right: true,
      },
      {
        id: 6,
        name: i18n.t('paid_amount'),
        width: '120px',
        cell: (row) => Number(row.paid_amount ?? 0).toFixed(3),
        wrap: true,
        right: true,
      },
      {
        id: 7,
        name: i18n.t('payable_balance'),
        width: '140px',
        cell: (row) => Number(row.balance_amount ?? 0).toFixed(3),
        wrap: true,
        right: true,
      },
      {
        id: 8,
        name: i18n.t('invoice'),
        width: '130px',
        cell: (row) =>
          row.approve_status === 'A' ? (
            <a
              href={
                apiUrl +
                'my_winnings/pdf?' +
                new URLSearchParams({
                  id: user.id,
                  auction: row.id,
                }).toString()
              }
              target="_blank"
              rel="noreferrer"
              className="button-table"
            >
              {i18n.t('download')}
            </a>
          ) : (
            '-'
          ),
        wrap: true,
        center: true,
      },
      {
        id: 9,
        name: i18n.t('due_days'),
        width: '120px',
        cell: (row) => {
          if (!row.approved_date) return '-';
          const approvedDate = new Date(row.approved_date);
          const today = new Date();
          const diffTime = approvedDate.getTime() - today.getTime();
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          return diffDays >= 0 ? `${diffDays} days left` : `${Math.abs(diffDays)} days overdue`;
        },
        wrap: true,
        center: true,
      },
      {
        id: 10,
        name: i18n.t('client_approval'),
        width: '140px',
        cell: (row) => <StatusBadge status={AUCTION_APPROVE_STATUS[row.approve_status]} />,
        wrap: true,
        center: true,
      },
    ];
  };

  handleSearchChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      (prevState) => {
        const updatedSearch = { ...prevState.search, [name]: value };
        return { search: updatedSearch };
      },
      () => {
        if (name === 'client') {
          this.getAllGroups();
        }
      }
    );
  };

  handleSearch = () => {
    this.getWinningAuctions();
  };

  handleClear = () => {
    const defaultSearch = {
      client: '',
      group: '',
      // status: 'pending',
    };

    this.setState({ search: defaultSearch, page: 1 }, () => {
      this.updateUrlQuery({ page: 1, limit: this.state.limit });
      this.getWinningAuctions();
    });
  };

  onChangePage = (page) => {
    console.log('page', page);

    this.setState({ page: page }, () => {
      this.getWinningAuctions();
    });
  };

  onChangeRowsPerPage = (limit) => {
    console.log('row', limit);
    this.setState({ limit: limit, page: 1 }, () => {
      this.getWinningAuctions();
    });
  };

  render() {
    const { clients, groups, winningAuctions, groupLoading } = this.state;

    return (
      <React.Fragment>
        {/* <HomeBanner /> */}
        <HeaderBanner
          title={i18n.t('winning_bids')}
          subtitle={i18n.t('track_your_successful_bid')}
        />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="header-action">
                      <NewDropdown
                        label={i18n.t('export')}
                        // loading={export_loading}
                        icon={Download}
                        items={[
                          {
                            label: i18n.t('pdf'),
                            icon: Printer,
                            onClick: () => this.handleDownload('pdf'),
                          },
                        ]}
                      />
                    </div>

                    <FilterSection
                      loading={this.state.isloading}
                      onSearch={this.handleSearch}
                      onClear={this.handleClear}
                    >
                      {/* Client Dropdown */}
                      <Dropdown
                        name="client"
                        value={this.state.search.client}
                        onChange={this.handleSearchChange}
                        placeholder={i18n.t('client_name')}
                        empty={i18n.t('select_client')}
                        options={clients.map((c) => ({ value: c.id, label: c.organization_name }))}
                      />
                      {/* Group Dropdown */}
                      <Dropdown
                        name="group"
                        value={this.state.search.group}
                        onChange={this.handleSearchChange}
                        placeholder={i18n.t('auction_group')}
                        empty={groupLoading ? `${i18n.t('loading')}...` : i18n.t('select_group')}
                        options={groups.map((g) => ({ value: g.id, label: g.group_name }))}
                        disabled={groupLoading}
                      />
                    </FilterSection>

                    <div className="Data-Listing">
                      {this.state.isloading ? (
                        <TableSkeleton columns={10} rows={10} />
                      ) : this.state.winningAuctions.length ? (
                        <DataTable
                          responsive={true}
                          columns={this.getColumns()}
                          data={winningAuctions}
                          customStyles={tableStyles}
                          highlightOnHover
                          pagination
                          paginationServer
                          paginationTotalRows={this.state.total}
                          paginationPerPage={this.state.limit}
                          paginationDefaultPage={this.state.page}
                          paginationRowsPerPageOptions={[15, 25, 50, 100]}
                          paginationComponentOptions={{
                            rowsPerPageText: i18n.t('rows_per_page'),
                            rangeSeparatorText: i18n.t('out'),
                          }}
                          onChangePage={this.onChangePage}
                          onChangeRowsPerPage={this.onChangeRowsPerPage}
                        />
                      ) : (
                        <NoData
                          message="No Auctions Available"
                          actionText="Refresh"
                          onAction={this.getWinningAuctions.bind(this)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
